<template>
  <div>
    <div class="container-fluid">
      <div class="row row-eq-height">
        <div class="col-sm-6 blue-grad-bg"><br>
          <div class="row">
            <form @submit.prevent="submit" class="col-md-6 col-md-offset-3 text-center pad-top">
              <h1 class="text-uppercase">Admin Rebate Portal</h1>
              <input
                type="username"
                class="form-control admin-form-control input-lg"
                id="userName"
                placeholder="Username"
                v-model.trim="userFields.username"
                >
              <input
                type="password"
                class="form-control admin-form-control input-lg"
                id="userPass"
                placeholder="Password"
                v-model.trim="userFields.password"
                >
              <button
                type="submit"
                class="btn admin-btn-primary btn-lg btn-block text-uppercase"
                @click.prevent.stop="submit"
                >
                Log In
              </button>
              <br>
              <router-link to="register">Register</router-link>
              <br>
              <a href="#" class="small">I forgot my login info</a>
              <br>
              <br>
              <br>
            </form>
          </div>
        </div>
        <div class="col-sm-6">
          <div class="row">
            <div class="col-md-6 col-md-offset-3 text-center pad-top">
              <img src="../../assets/images/blue-icon.png" class="img-responsive center-block">
            </div>
            <br>
            <br>
            <br>
          </div>
        </div>
      </div>
    </div><!-- container-fluid -->
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'AdminLogin',
  data () {
    return {
      userFields: {
        isAdmin: true
      },
      errors: []
    }
  },
  methods: {
    ...mapActions('auth', [
      'login'
    ]),
    submit () {
      this.login(this.userFields)
        .then(() => this.$router.push({ name: 'AdminDashboard' }))
        .catch(err => console.log(err))
    }
  }
}
</script>
